import { CarrierSuggestionBadge, RequiredBadge } from "@/shared/ui/base-badge";
import { InputLabel, Stack, type SxProps, type Theme } from "@mui/material";

export const BaseFormLabel = ({
  label,
  children,
  sx,
  isRequired = false,
  isSuggestedByCarrier = false,
}: {
  label: string;
  children: React.ReactElement;
  sx?: SxProps<Theme>;
  isRequired?: boolean;
  isSuggestedByCarrier?: boolean;
}) => {
  return (
    <Stack spacing={1} sx={sx}>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <InputLabel
          sx={{
            color: "grey.900",
            fontSize: 14,
            fontWeight: 500,
            marginBottom: 1,
          }}
        >
          {label}
        </InputLabel>
        {isRequired && <RequiredBadge />}
        {isSuggestedByCarrier && <CarrierSuggestionBadge />}
      </Stack>
      {children}
    </Stack>
  );
};
